import { skipToken } from '@reduxjs/toolkit/query';
import { useGetCustomerQuery } from '../impl/blfApi/endpoints/customers';

export const useCustomer = (customerId: string | undefined) => {
  const { data, isLoading, isFetching } = useGetCustomerQuery(
    customerId || skipToken
  );

  return { customer: data, isCustomerLoading: isLoading || isFetching };
};
